import { render, staticRenderFns } from "./BrandCreateEdit.vue?vue&type=template&id=4889f5ed&scoped=true&"
import script from "./BrandCreateEdit.vue?vue&type=script&lang=js&"
export * from "./BrandCreateEdit.vue?vue&type=script&lang=js&"
import style0 from "./BrandCreateEdit.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./BrandCreateEdit.vue?vue&type=style&index=1&id=4889f5ed&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4889f5ed",
  null
  
)

export default component.exports